import { Observable } from 'rxjs'

export function observeIntersection$(element: Element): Observable<IntersectionObserverEntry> {
  return new Observable<IntersectionObserverEntry>((observer) => {
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        observer.next(entry)
      })
    })
    intersectionObserver.observe(element)
    return () => intersectionObserver.disconnect()
  })
}
